"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeDefaultProps = void 0;
var _ = require('lodash');
function mergeDefaultProps(defaultProps, props) {
  defaultProps = !defaultProps ? {} : _.cloneDeep(defaultProps);
  props = !props ? {} : _.cloneDeep(props);
  var outProps = _.merge(defaultProps, props);
  return outProps;
}
exports.mergeDefaultProps = mergeDefaultProps;